export const LAYER_TYPE_REPORT = 1
export const LAYER_TYPE_DEMO = 2
export const LAYER_TYPE_CAMP_GEO = 3
export const LAYER_TYPE_PROXIMITY = 4
export const LAYER_TYPE_DEMOGRAPHIC = 19
export const LAYER_TYPE_PROPENSITY = 20
export const LAYER_TYPE_POI = 'poi-layer'
export const WIDGET_TYPE_POI = 'poi' // poi
export const WIDGET_TYPE_GQ_POI = 'geo-query-poi' // iso, prox, aoi
export const WIDGET_TYPE_GQ = 'geo-query' // draw, interaction
export const WIDGET_TYPE_SLATE_WI = 'poi_wi'
export const WIDGET_TYPE_SLATE_VWI = 'poi_vwi'

// mainCategory:
//    report: 1
//    demo: 2
//    camp geo: 3
export const layerTypes = {
  1: {
    name: 'report',
    fullName: 'walk-in report',
    mainCategory: LAYER_TYPE_REPORT,
  },
  2: {
    name: 'report',
    fullName: 'verified walk-in report',
    mainCategory: LAYER_TYPE_REPORT,
  },
  3: {
    name: 'campaign geo',
    fullName: 'campaign geo',
    mainCategory: LAYER_TYPE_CAMP_GEO,
  },
  4: {
    name: 'demographic',
    fullName: 'demographic ca db',
    mainCategory: LAYER_TYPE_DEMO,
  },
  5: {
    name: 'demographic',
    fullName: 'demographic ca da',
    mainCategory: LAYER_TYPE_DEMO,
  },
  6: {
    name: 'demographic',
    fullName: 'demographic ca ct',
    mainCategory: LAYER_TYPE_DEMO,
  },
  7: {
    name: 'demographic',
    fullName: 'demographic ca ca',
    mainCategory: LAYER_TYPE_DEMO,
  },
  8: {
    name: 'demographic',
    fullName: 'demographic ca sd',
    mainCategory: LAYER_TYPE_DEMO,
  },
  9: {
    name: 'demographic',
    fullName: 'demographic ca csd',
    mainCategory: LAYER_TYPE_DEMO,
  },
  10: {
    name: 'demographic',
    fullName: 'demographic ca ada',
    mainCategory: LAYER_TYPE_DEMO,
  },
  11: {
    name: 'demographic',
    fullName: 'demographic ca cd',
    mainCategory: LAYER_TYPE_DEMO,
  },
  12: {
    name: 'demographic',
    fullName: 'demographic ca fed',
    mainCategory: LAYER_TYPE_DEMO,
  },
  13: {
    name: 'demographic',
    fullName: 'demographic ca er',
    mainCategory: LAYER_TYPE_DEMO,
  },
  14: {
    name: 'demographic',
    fullName: 'demographic ca pr',
    mainCategory: LAYER_TYPE_DEMO,
  },
  15: {
    name: 'demographic',
    fullName: 'demographic ca fsa',
    mainCategory: LAYER_TYPE_DEMO,
  },
  16: {
    name: 'report',
    fullName: 'cross walk-in',
    mainCategory: LAYER_TYPE_REPORT,
  },
  17: {
    name: 'report',
    fullName: 'cross verified walk-in',
    mainCategory: LAYER_TYPE_REPORT,
  },
  18: {
    name: 'demographic',
    fullName: 'demographic ca da',
    mainCategory: LAYER_TYPE_DEMOGRAPHIC,
  },
  19: {
    name: 'demographic',
    fullName: 'demographic ca ct',
    mainCategory: LAYER_TYPE_DEMOGRAPHIC,
  },
  20: {
    name: 'propensity',
    fullName: 'Propensity',
    mainCategory: LAYER_TYPE_PROPENSITY,
  },
  21: {
    name: 'poi',
    fullName: 'point of interest',
    mainCategory: LAYER_TYPE_POI,
  },
}

export const getLayerType = (layerTypeID) => layerTypes[layerTypeID] || { name: '', mainCategory: -1 }

export const layersStyles = {
  [LAYER_TYPE_REPORT]: {
    color: 'blue',
    icon: 'map marker alternate',
  },
  [LAYER_TYPE_PROPENSITY]: {
    color: 'green',
    icon: 'map',
  },
  [LAYER_TYPE_DEMOGRAPHIC]: {
    color: 'orange',
    icon: 'map',
  },
  [LAYER_TYPE_POI]: {
    color: 'purple',
    icon: 'map marker alternate',
  },
}

export const getLayerStyle = (type) => {
  const defaultStyle = {
    color: 'red',
    icon: null,
  }
  return layersStyles[type] || defaultStyle
}
